import React from "react";
import SocialTwo from "../../Social/SocialTwo";

const CopyRight = () => {
  return (
    <div className="row align-items-center justify-content-center">
      <div className="col-12 col-md text-md-center text-lg-center">
        <p className="ptf-footer-copyright has-black-color">
          ©{new Date().getFullYear()} <span>Githubit</span>. All Rights
          Reserved.
        </p>
      </div>
      <div className="col-12 col-lg text-md-center text-lg-center mt-4">
        <div className="ptf-footer-socials has-black-color ">
          <SocialTwo />
        </div>
      </div>
    </div>
  );
};

export default CopyRight;
